var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginPage"},[_c('div',{staticClass:"sticky"},[_c('NavBar',{attrs:{"bgColor":'#1A3232'}})],1),_c('Login',{attrs:{"loginType":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }